import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { jwtDecode } from 'jwt-decode';
import userService from '../../services/UserService';
import Logo from '../../components/logo/Logo';
import "./Login.css";
import welcome from '../../static/images/auguri_skillati.png';

export default function Login() {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const handleShowPassword = () => {
        setShowPassword(!showPassword);
    };

    // Controlla subito se l'utente è già loggato
    useEffect(() => {
      const token = localStorage.getItem('token');
      if (token) {
        // Se il token è presente, verifichiamo se è valido
        try {
          const decodedToken = jwtDecode(token);
          if (decodedToken.exp * 1000 > Date.now()) {
            // Se il token è valido, reindirizza l'utente alla home
            navigate('/home');
          }
        } catch (error) {
          console.error('Errore nel decoding del token:', error);
        }
      }
    }, [navigate]);

    const onSubmit = async (data) => {
        userService.login(data)
        .then((res) => {
            if (res.status === 200) {
                const { token, id_user, username, name, address, comune, phone, avatar, role, createdAt } = res.data;
                // Memorizza il JWT e i dati utente nel localStorage
                localStorage.setItem("token", token);
                localStorage.setItem("id_user", id_user);
                localStorage.setItem("username", username);
                localStorage.setItem("name", name);
                localStorage.setItem("address", address);
                localStorage.setItem("comune", comune);
                localStorage.setItem("phone", phone);
                localStorage.setItem('avatar', avatar || '');
                localStorage.setItem("role", role);
                localStorage.setItem("createdAt", createdAt);

                navigate('/home');  // Redirect alla home
            }
        }).catch((error) => {
            if (error.status === 401)  {
                setError('Credenziali non valide');
            } else {
                setError('Errore durante il login, riprovare');
                console.log(error);
            }
        });
    }

    return (
        <div className="authentication-wrapper authentication-cover">
            {/* Per ora togliamo il <Logo/> */}
            <div className="authentication-inner row m-0">
                <div className="d-none d-lg-flex col-lg-6 col-xl-6 align-items-center p-5">
                    <div className="w-100 d-flex justify-content-center">
                        <img src={welcome} className="img-fluid" alt="Login image"/>
                    </div>
                </div>
                <div className="d-flex col-12 col-lg-6 col-xl-6 align-items-center authentication-bg p-sm-12 p-6">
                    <div className="w-px-400 mx-auto mt-12 pt-5">
                        <h4 className="mb-1">Benvenuto</h4>
                        <p className="mb-6">Accedi al tuo account</p>
                        <form className="mb-6 custom-form" onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-6">
                                <label htmlFor="username" className="form-label">Email</label>
                                <input type="text" autoComplete="username" className={`form-control ${errors.username ? "is-invalid" : ""}`}
                                    placeholder="Inserisci la tua email"
                                    {...register('username', { required: 'Inserisci un Email valida!' ,
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: "Email non valida!"
                                        }
                                    })}
                                />
                                {errors.username && <div className="invalid-input">{errors.username.message}</div>}
                            </div>
                            <div className="mb-6">
                                <label htmlFor="password" className="form-label">Password</label>
                                <div className="input-group input-group-merge has-validation">
                                    <input type={`${showPassword ? "text" : "password"}`} autoComplete="password" className={`form-control ${errors.password ? "is-invalid" : ""}`}
                                        placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;" aria-describedby="password"
                                        {...register('password', { required: 'Inserisci la password' })}
                                    />
                                    <span className="input-group-text cursor-pointer"><i onClick={handleShowPassword}
                                    className={`bx ${showPassword ? "bx-show" : "bx-hide"}`} ></i></span>
                                    {errors.password && <div className="invalid-input">{errors.password.message}</div>}
                                </div>
                            </div>
                            <button type="submit">Login</button>
                        </form>
                        {error && <p className="text-center is-invalid"> <span>{error}</span></p>}
                        <p className="text-center"> <span>Hai dimenticato la password?</span>
                            <a><span> Richiedi</span></a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
